export default "__VITE_ASSET__BKsatWuj__"